<template>
  <div>
    <Navigation></Navigation>
    <Filters></Filters>
    <ContentBody v-if="!globalLoading"></ContentBody>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Navigation from './Navigation.vue';
  import Filters from './Filters.vue';
  import ContentBody from './ContentBody.vue';

  export default {
    name: 'AudiologyKpis',
    components: {
      Navigation,
      Filters,
      ContentBody,
    },
    async mounted() {
      await this.$store.dispatch('audiologyKpis/getBenchmarks');
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    computed: {
      ...mapGetters('main', ['globalLoading']),
    },
  };
</script>
